<template>
  <div class="breadcrumb u-bg--white">
    <simple-link :text="'Accueil'" :href="'/'" class="u-color--blue"/><span> > {{text}}
    </span>
  </div>
</template>

<script>
  import SimpleLink from "./Link/SimpleLink";
  export default {
    name: "Breadcrumb",
    components: {SimpleLink},
    props: ['text']
  }
</script>

<style lang="scss">
  .breadcrumb {
    display: flex;
    font-size: rem(13px);
    line-height: rem(16px);

    .link {
      margin: 0 rem(5px) 0 0;
    }

    span {
      font-weight: 700;
    }

    @include mq($until: MD) {
      font-size: rem(10px);
      line-height: rem(13px);
    }
  }
</style>